import React, { Fragment, PureComponent } from "react";
import { PropTypes } from "prop-types";
import { UISref } from "@uirouter/react";
import classNames from "classnames";
import i18n from "i18next";

import { DropDown } from "./../Common/DropDown";
import { Icon } from "./../Common/Icon";
import { hasUserAtLeastOneRole } from "../../helpers/Authorization/authorizationHelpers";

export default class SettingsDropDown extends PureComponent {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    pictureSrc: PropTypes.string,
    userName: PropTypes.string
  };

  static defaultProps = {
    isAuthenticated: false,
    pictureSrc: "",
    userName: ""
  };

  state = {
    isUserDropdownOpen: false
  };

  closeUserDropdown = () => {
    this.setState({ isUserDropdownOpen: false });
    document.removeEventListener("click", this.closeUserDropdown);
  };

  openUserDropdown = () => {
    this.setState({ isUserDropdownOpen: !this.state.isUserDropdownOpen });
    document.addEventListener("click", this.closeUserDropdown);
  };

  render() {
    const hasAtLeastOneRole = hasUserAtLeastOneRole();

    return (
      <div className="navbar__menu">
        <button className={classNames("navbar__button", { "-no-touch": this.state.isUserDropdownOpen })} onClick={this.openUserDropdown}>
          {this.props.isAuthenticated ? (
            <Fragment>
              <figure className="navbar__avatar" style={{ backgroundImage: `url(${this.props.pictureSrc})` }} />
              <span className="navbar__user">
                <p>{this.props.userName}</p>
              </span>
            </Fragment>
          ) : (
            <span className="navbar__user">{i18n.t("navbar.menu")}</span>
          )}
          <Icon className="navbar__arrow-down" id="arrow-down" />
        </button>
        {this.props.isAuthenticated && (
          <DropDown className="dropdown navbar__dropdown" contentTag="menu" contentClass="navbar__list" isOpen={this.state.isUserDropdownOpen}>
            {hasAtLeastOneRole && (
              <Fragment>
                <li key="user-preferences">
                  <UISref to="user-preferences">
                    <a className="navbar__link">{i18n.t("navbar.setting")}</a>
                  </UISref>
                </li>
                <li key="help">
                  <UISref to="help">
                    <a className="navbar__link">{i18n.t("navbar.help")}</a>
                  </UISref>
                </li>
              </Fragment>
            )}
            <li key="logout">
              <UISref to="logout">
                <a className="navbar__link">{i18n.t("navbar.logout")}</a>
              </UISref>
            </li>
          </DropDown>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/SettingsDropDown.js